import clsApiPost from '@cls/clsApiPost'

class clsContractTypeApi extends clsApiPost {


    uploadAttachment(formData) {
        return this.upload(formData, 'attachment/upload');
    }

    /**
     * remove one or more attachment - either workorder- or appointment related.
     */
    removeAttachment(id) {
        return this.post(`attachment/remove`, {id: id}); 
    }

    /**
     * download an attachment
     */
    async loadAttachment(id, bDownload) {
        if (bDownload) {
            return await this.downloadPost(`attachment/load`, {id: id});  
        }
        return await this.postRaw(`attachment/load`, {id: id});  
    }

}

export default clsContractTypeApi;
